import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CreateDataFeedSharedService } from '../../create-data-feed-shared.service';

@Component({
    selector: 'cv-action-renderer',
    templateUrl: './action-renderer.component.html',
    styleUrls: ['./action-renderer.component.scss']
})
export class ActionRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParams;
    isValidData = false;
    disableEditIcon = false;

    constructor(
        private createDataFeedSharedService: CreateDataFeedSharedService
    ) { }

    refresh() {
        return false;
    }

    agInit(params: ICellRendererParams) {
        this.params = params;
        this.disableEditIcon = params.node.data.disableEditBtn;
        this.enableDisableSaveBtn(params);
    }

    ngOnInit(): void {
        this.createDataFeedSharedService.fieldNameChanged$.subscribe((rowParams) => {
            this.enableDisableSaveBtn(rowParams);
        });
        this.createDataFeedSharedService.dataTypeChanged$.subscribe((rowParams) => {
            this.enableDisableSaveBtn(rowParams);
        });
        this.createDataFeedSharedService.primaryKeyChanged$.subscribe((rowParams) => {
            this.enableDisableSaveBtn(rowParams);
        });
        this.createDataFeedSharedService.activeChanged$.subscribe((rowParams) => {
            this.enableDisableSaveBtn(rowParams);
        });

    }

    public enableDisableSaveBtn(rowParams) {
        if (rowParams.node.data.editable) {
            if (rowParams.node.data.fieldNameValid && rowParams.node.data.dataType !== undefined) {
                this.isValidData = true;
            } else {
                this.isValidData = false;
            }
        }
    }

    cancelRowEditing() {
        if (this.validInputParam()) {
            this.params.context.componentParent.cancelEditing(this.params);
        }
    }

    saveRowData() {
        if (this.validInputParam()) {
            this.params.context.componentParent.saveEditing(this.params);
        }
    }

    isEditable() {
        if (this.validInputParam()) {
            return this.params.node.data.editable;
        }
    }

    editRow() {
        if (this.validInputParam()) {
            this.params.context.componentParent.editRowData(this.params);
        }
    }

    deleteRow() {
        this.params.context.componentParent.deleteRow(this.params);
    }

    public validInputParam() {
        let validInput = true;
        if (this.params === null || this.params === undefined) {
            validInput = false;
        }
        return validInput;
    }

}
